/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
*/
import {useSelector} from 'react-redux';
import {solomonIdSelector} from '../store/selectors/global-group';

/**
 * Custom hook for retrieving the global account solomon id.
 */
export const useGlobalAccountSolomonId = (): string => useSelector(solomonIdSelector);
